function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.55,3.7A5.25,5.25,0,1,0,18.8,9,5.26,5.26,0,0,0,13.55,3.7Zm0,9A3.75,3.75,0,1,1,17.3,9,3.75,3.75,0,0,1,13.55,12.7Zm0-12.7C6.08,0,0,4,0,9s6.08,9,13.55,9S27.1,13.89,27.1,9,21,0,13.55,0Zm0,16.4c-6.64,0-12-3.34-12-7.45S6.91,1.5,13.55,1.5,25.6,4.84,25.6,9,20.19,16.4,13.55,16.4Z"
});

var SvgView = function SvgView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.1,
    height: 17.9,
    viewBox: "0 0 27.1 17.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view.b28ff41c.svg";
export { ForwardRef as ReactComponent };